//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

//*******************Demo pattern of objects****************
// {
//   img:
//     "https://drive.google.com/uc?export=view&id=",
//   frame: "",
//   location: ""
// },

export const moonURLs = [
  {
    img:
      "https://drive.google.com/uc?export=view&id=1dBAgM8vb10e6Y7EhRz35czZ8-1WnnuxQ",
    frame:
      "An amazing view of the sky captured on mirror by One Plus nord + google cam",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1dIfeA9c9WBajwwQc4cOgkiH0e-LdfUO-",
    frame: "Shooting start captured with One plus nord + google cam",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1sQ7C6hcUsDE64-511FtIfRMWWVlMwwWB",
    frame:
      "Stars captured with One plus nord + google cam in astrophotography mode",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12ea3MVjBmfK-FAGYcMYkIlXg4aVbbSSP",
    frame: "Moon as viewed before full moon night",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12WndmjxEWYwsBD3nngK6r1bBPXz31P-V",
    frame: "Solar Eclipse as on 21st June 2020",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12_-xGZDIoE-QMSgeg8VaW1XYf3JDsyQ6",
    frame: "Solar Eclipse as on 21st June 2020",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12ge6-SaXweOaBWBnsU4CmLpHFWJwL5-t",
    frame: "Different phases of moon from 30th Jan'20 -  5th feb'20",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12gMkpicw3M_jPqMENtuthG1cHsjKLOIk",
    frame: "Different phases of moon from 6th feb'20 - 10th feb'20",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12iNKxqCnbvtv75yMv4FMgrxbNkoKQSwH",
    frame: "A bird beautifully focused in front of the moon",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=131bJnjy08jK0-YlsbsLYDFFkfkxTmKRS",
    frame: "A phase of moon",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=131by8Kj3kOMkARCJShSDjXMHG7Z27eij",
    frame: "A phase of moon",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12xk0qlLUk1x6YqQSrgEVYyBGt0RHeeuO",
    frame: "Moon as captured in daylight",
    location: "Pune, Maharashtra, India",
  },
];
